/* Wire the header hamburger to the YB drawer, and own the glyph outright.

   Dawn's drawer summary ships its own icon-hamburger and icon-close, styled and
   positioned by Dawn's stylesheet, and the search summary ships a second
   icon-close. Trying to reveal/hide the right one from CSS kept producing
   either a stray X beside the magnifier or an invisible glyph. The summary's
   contents are replaced here with two SVGs this theme controls completely, so
   position and colour are never in question.

   Dawn's own drawer panel is left in the DOM but never opened: it lives inside
   .header and inherits the overlay rule that whitens the bar over the hero,
   which rendered all of its links white on a white panel. */
(function () {
  'use strict';

  var BARS =
    '<svg class="yb-burger" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false">' +
    '<path d="M3 6h18M3 12h18M3 18h18"/></svg>';
  var EX =
    '<svg class="yb-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false">' +
    '<path d="M5 5l14 14M19 5L5 19"/></svg>';

  function init() {
    var menu = document.getElementById('yb-menu');
    var scrim = document.querySelector('[data-yb-menu-scrim]');
    var header = document.querySelector('.header');
    if (!menu || !header) return;

    var summary = header.querySelector('header-drawer summary');
    if (!summary) return;

    /* Own the glyph: drop Dawn's icons, render ours */
    summary.innerHTML = BARS + EX;
    summary.setAttribute('aria-expanded', 'false');
    summary.setAttribute('aria-controls', 'yb-menu');
    summary.setAttribute('aria-label', 'Menu');

    if (scrim) scrim.hidden = false;

    function place() {
      var h = header.getBoundingClientRect().height || 66;
      menu.style.setProperty('--yb-menu-top', Math.round(h) + 'px');
    }

    function open() {
      place();
      menu.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.classList.add('yb-menu-open');
      summary.setAttribute('aria-expanded', 'true');
      var first = menu.querySelector('a, summary');
      if (first) first.focus({ preventScroll: true });
    }

    function close() {
      menu.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.classList.remove('yb-menu-open');
      summary.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      if (menu.classList.contains('is-open')) close();
      else open();
    }

    /* Capture phase, so Dawn's details toggle never fires */
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var det = summary.closest('details');
      if (det) det.open = false;
      toggle();
    }, true);

    summary.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        toggle();
      }
    }, true);

    if (scrim) scrim.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) {
        close();
        summary.focus();
      }
    });

    menu.addEventListener('click', function (e) {
      if (e.target.closest('a')) close();
    });

    /* Opening search should close the drawer, and vice versa */
    var searchDetails = header.querySelector('.header__search > details');
    if (searchDetails) {
      searchDetails.addEventListener('toggle', function () {
        if (searchDetails.open && menu.classList.contains('is-open')) close();
      });
    }

    window.addEventListener('resize', function () {
      if (menu.classList.contains('is-open')) place();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
